export const translations = {
  'home': {
    'free': 'Free'
  },
  'playNarration': 'Press Play to start the narration',
  "supportSonamaInfo":{
    "supportHead":"Support Sonoma Plaza History",
    "donateNow":"Donate Now",
    "mailingList":"Join our Mailing List"
  },
  'loadingStop' : {
    'loadingTourStop': 'Loading tour stop',
    'forBestExperience': 'For best experience...',
    'wiFiIsTurnedOff': 'Make sure local outside WiFi is turned off',
    'loadingTour': 'Click to continue'
  },
  'welcomePage':{
    'free':"Free",
    'walking':"Walking",
    'devices':'Devices',
    '1Hour':'1 Hour',
    'welcomeTo':'Welcome to the Sonoma Plaza History tour',
    'weAreSo':'We are so excited that you are joining us on this adventure through time.',
    'chooseYour':'Choose your starting point',
    'launchFirst':'Launch first stop',
    'ourFirst':'Our first stop takes place at City Hall',
    'jumpTo':'Jump to another tour stop',
    'pickUp':'Pick up where you left off.',
    'tourInformation':'Tour Information',
    'location':'Location - Sonoma Plaza',
    'allDestinations':'All destinations on this tour are located within walking distance of the Sonoma Plaza, located at',
    'plazaSonama':'1 Plaza, Sonoma, Ca,',
    'deviceAccess':'Device access',
    'thisAWeb':'This a web based application that you can access from any internet connected mobile device or home computer via web browser.',
    'parking':'Parking',
    'forWalking':'For walking tour, make sure you are parked around the Sonoma Plaza and ready to walk to your destination.',
    'moreInformation':'More Information coming soon'
  },
  'chooseStop':{
    'back':'Back',
    'new':'NEW!',
    'jumpTo':'Jump to any destination.',
    'stop':'Stop',
    'launch': 'Launch stop'
  },
  'stopCard': {
    'nextStop': 'Next stop',
    'arrivedButton': "I've Arrived",
    'continueButton': 'Continue'
  },
  'sideNavBar': {
    'home': 'Home',
    'allStops': 'List of all stops',
    'troubleshooting': 'Troubleshooting',
    'donate': 'Donate',
    'exitTour': 'Exit Tour'
  }
}
